import { Checkout } from "@/components/checkout/checkout";
import { env } from "@/env";
import { GetServerSidePropsContext } from "next";

export default function CheckoutPage({
  cartToken,
  isMobile,
  paymentMethodsIncludes,
  inFrame,
}: {
  cartToken: string;
  isMobile: boolean;
  paymentMethodsIncludes?: string;
  inFrame?: boolean;
}) {
  return (
    <Checkout
      inFrame={inFrame}
      cartToken={cartToken}
      isMobile={isMobile}
      paymentMethodsIncludes={paymentMethodsIncludes}
    />
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const cartToken = context.params?.cartToken as string;
  const inFrame = context.query.inFrame === "true";
  const isMobile = context.query.isMobile === "true";
  const paymentMethodsIncludes =
    (context.query.payment_methods_includes as string) || null;

  if (context.query["3ds"] === "true") {
    try {
      const response = await fetch(
        `${env.NEXT_PUBLIC_FLUID_API_URL}/carts/${cartToken}/metadata`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "x-fluid-client": "checkout",
          },
          body: JSON.stringify({ metadata: { force_3ds: true } }),
        },
      );
      if (!response.ok) {
        console.error(`Failed to set force_3ds metadata: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to set force_3ds metadata:", error);
    }
  }

  return {
    props: {
      cartToken,
      isMobile,
      paymentMethodsIncludes,
      inFrame,
    },
  };
}
